module.exports = __webpack_public_path__ + "static/media/testimonials-genevieve.cdf35174.png";